const getCounties = `
    query getCounties($stateCode:String!, $countryCode:String!)
    {
        counties(stateCode:$stateCode, countryCode:$countryCode)
    }
`;

export default getCounties;
